import React, { FC } from 'react';

import {
  Box,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';

import AllowanceWorkshift from '../../../../SelfService/Workshifts/AllowanceWorkshift';
import AllowanceAdminWorkshift from '../../../EditWorkshift/AllowanceAdminWorkshift';
import CustomButton from '../../../../common/CustomButton';
import CustomDialogTitle from '../../../../common/CustomModal/ModalCommon/CustomDialogTitle';
import CustomTextField from '../../../../common/CustomTextField';
import useUpdateWorkshiftRateAllowances from '../../../../../hooks/Admin/PharmacyList/useUpdateWorkshiftRateAllowances';
import strings from '../../../../../localization';
import genericClasses from '../../../../../theme/GenericClasses';

import styles from './styles';

interface IUpdateWorkshiftsModal {
  pharmacyId: string;
  shiftIds: Array<string>;
}

const UpdateWorkshiftsModal: FC<IUpdateWorkshiftsModal> = ({
  pharmacyId,
  shiftIds,
}) => {
  const {
    formik,
    handleClose,
    isSubmitting,
  } = useUpdateWorkshiftRateAllowances(shiftIds);
  const selectedShiftCount = shiftIds.length;

  return (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <CustomDialogTitle
        headingTitle={strings.updateShifts}
        onClickClose={handleClose}
        customStyle={{
          customTitleContainer: styles.titleContainer,
          customModalHeading: styles.modalHeading,
        }}
      />
      <Typography sx={styles.subtitle}>
        {strings.formatString(
          strings.updateSelectedShiftsNotice,
          selectedShiftCount,
        )}
      </Typography>

      <DialogContent sx={styles.content}>
        <AllowanceWorkshift
          pharmacyId={pharmacyId}
          formik={formik}
          isAdmin
          renderHourlyRate={<AllowanceAdminWorkshift formik={formik} />}
        />

        <Box sx={styles.notes}>
          <CustomTextField
            variant="outlined"
            formik={formik}
            id="notes"
            placeholder=" "
            label={strings.notes}
            name="notes"
            multiline
            maxLength={200}
            customClass={genericClasses.borderNoneTextField}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={styles.actions}>
        <CustomButton
          type="submit"
          fullWidth={false}
          disabled={isSubmitting}
          label={strings.updateShifts}
          customButtonStyle={styles.updateButton}
        />
      </DialogActions>
    </Box>
  );
};

export default UpdateWorkshiftsModal;
